import { createContext, useContext } from "react";

export type MotionContextValue = {
  reducedMotion: boolean;
  setReducedMotion: (value: boolean) => void;
};

export const MOTION_STORAGE_KEY = "vv-reduced-motion";

export const MotionContext = createContext<MotionContextValue | null>(null);

export function useMotionPreference(): MotionContextValue {
  const ctx = useContext(MotionContext);
  if (!ctx) {
    throw new Error("useMotionPreference debe usarse dentro de un MotionPreferenceProvider");
  }
  return ctx;
}